import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { FaTrophy, FaBriefcase, FaMapMarkerAlt, FaGraduationCap, FaStar, FaQuoteLeft, FaRunning } from 'react-icons/fa';
import './Achievement.css';
import breadcrumb from '../../assets/breadcrumb/Awards.jpg';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Achievement() {
  const [alumniData, setAlumniData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/achievements/public`);
        const data = await response.json();
        setAlumniData(data);
      } catch (error) {
        console.error("Failed to fetch achievements:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAchievements();
  }, []);

  return (
    <>
      <Helmet>
        <title>Student Achievements | SK College</title>
        <link rel="preload" as="image" href={breadcrumb} />
        <meta
          name="description"
          content="Explore the achievements of SK College students including government selections, merit holders, and successful career placements."
        />
        <meta property="og:title" content="Student Achievements - SK College" />
        <link rel="canonical" href="https://skcollegemanaklao.com/achievements" />
      </Helmet>
      
      <div className="achievement-of-sk-college-wrapper">
        
        {/* 1. Hero / Breadcrumb Section */}
        <div 
          className="achievement-of-sk-college-hero"
          style={{ backgroundImage: `url(${breadcrumb})` }}
        >
          <div className="achievement-of-sk-college-overlay"></div>
          <div className="achievement-of-sk-college-hero-content">
            <h1 className="achievement-of-sk-college-main-title">Student Achievement</h1>
            <div className="achievement-of-sk-college-breadcrumb-text">
              <span>Home</span>
              <span className="achievement-of-sk-college-sep">/</span>
              <span className="achievement-of-sk-college-active">Student Achievement</span>
            </div>
          </div>
        </div>

        {/* 2. Intro & Stats Section */}
        <div className="achievement-of-sk-college-intro-section">
          <div className="achievement-of-sk-college-container">
            <p className="achievement-of-sk-college-quote">
              "Our students continue to make us proud by excelling in academics, careers, sports, and public service."
            </p>
            <div className="achievement-of-sk-college-stats">
              <div className="achievement-of-sk-college-stat-item">
                <FaTrophy className="achievement-of-sk-college-stat-icon" />
                <div><strong>150+</strong><span>Govt Selections</span></div>
              </div>
              <div className="achievement-of-sk-college-stat-item">
                <FaStar className="achievement-of-sk-college-stat-icon" />
                <div><strong>50+</strong><span>Merit Holders</span></div>
              </div>
              <div className="achievement-of-sk-college-stat-item">
                <FaBriefcase className="achievement-of-sk-college-stat-icon" />
                <div><strong>500+</strong><span>Career Placements</span></div>
              </div>
              {/* --- NEW SPORTS SECTION ADDED HERE --- */}
              <div className="achievement-of-sk-college-stat-item">
                <FaRunning className="achievement-of-sk-college-stat-icon" />
                <div><strong>50+</strong><span>Sports Awards</span></div>
              </div>
            </div>
          </div>
        </div>

        {/* 3. Main Grid Section (FLIP LAYOUT) */}
        <div className="achievement-of-sk-college-grid-section">
          <div className="achievement-of-sk-college-container">
            <div className="achievement-of-sk-college-grid">
              {loading ? (
                <div className="achievement-of-sk-college-loading">
                  Loading Achievements...
                </div>
              ) : alumniData.length === 0 ? (
                <div className="achievement-of-sk-college-no-data">
                  No achievements found yet.
                </div>
              ) : (
                alumniData.map((student) => (
                  <div key={student._id} className="achievement-of-sk-college-flip-card">
                    <div className="achievement-of-sk-college-flip-card-inner">
                      
                      {/* --- FRONT SIDE --- */}
                      <div className="achievement-of-sk-college-flip-front">
                        <div className="achievement-of-sk-college-img-container">
                          <img 
                            src={`${API_BASE_URL}${student.image}`} 
                            alt={student.name} 
                            onError={(e) => e.target.src='https://via.placeholder.com/400x500?text=No+Image'}
                          />
                        </div>
                        <div className="achievement-of-sk-college-front-name">
                          {student.name}
                        </div>
                      </div>

                      {/* --- BACK SIDE --- */}
                      <div className="achievement-of-sk-college-flip-back">
                        <FaQuoteLeft className="achievement-of-sk-college-back-icon" />
                        <h3 className="achievement-of-sk-college-back-name">{student.name}</h3>
                        
                        <div className="achievement-of-sk-college-back-details">
                          <div className="achievement-of-sk-college-detail-row">
                            <FaGraduationCap className="achievement-of-sk-college-icon-gold" />
                            <span>{student.degree} ({student.year})</span>
                          </div>
                          
                          <div className="achievement-of-sk-college-divider-small"></div>
                          
                          <div className="achievement-of-sk-college-designation-box">
                            <h4>{student.post}</h4>
                          </div>
                          
                          <div className="achievement-of-sk-college-detail-row location-row">
                            <FaMapMarkerAlt className="achievement-of-sk-college-icon-gold" />
                            <span>{student.location}</span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default Achievement;